// extracted by mini-css-extract-plugin
export default {"cardMedia":"zH-z","shopText":"AH-z","videoPlayer":"BH-z","videoContainer":"CH-z"};